export class StateRestrictionModal {
  constructor() {

    this.modalContainer = document.querySelector('[data-state-restriction-modal-container]');
    this.modal = document.querySelector('[data-state-restriction-modal-content]');
    this.closeButton = document.querySelector('[data-close-state-restriction-modal]');
    this.quickBuyButtons = document.querySelectorAll('[data-brighside-quick-view]');
    this.stateShopperText = document.querySelector('[state-shopper-text]');
    this.productBrightside = document.querySelector('[data-product-brightside]');
    this.restrictionModalContent = document.querySelector('[restriction-modal-content]');

    this.init();

    if(window.location.pathname.includes('/products/')){
      if(this.productBrightside){
        this.locationCheck();
      }
    }
  }

  init(){
    console.log('StateRestrictionModal loaded');


    if(this.closeButton){
      this.closeButton,addEventListener('click', () => {
        this.closeModal();
      })
    }

    if(this.quickBuyButtons){
      this.quickBuyButtons.forEach(button => {
        button.addEventListener('click', () => {
          this.openModalFromCollection();
          // alert('Illinois');
        })
      })
    }

    this.restrictionModalContent.innerHTML = window.stateRestrictionData.modal_content;
  }


  locationCheck(){
      fetch('https://api.ipstack.com/check?access_key=3ea897f1cfa147712ea3f3946f081068')
      .then(response => response.json())
      .then(data => {
        console.log(data.region_name); // This will give you the state
        const restrictedStates = window.stateRestrictionData.restricted_states.split(',').map(state => state.trim());
        if(restrictedStates.includes(data.region_name)) {
          this.openModal(data.region_name);
          console.log(restrictedStates);
        }
      })
      .catch(error => {
        console.error('Error fetching IP data:', error);
      });

  }

  openModal(state_name){
    if(this.modalContainer){

      console.log(this.modalContainer);
      this.stateShopperText.innerHTML = `${state_name} Shopper `;

      setTimeout(() => {
        this.modalContainer.style.display = 'flex';
      }, 2000);
    }
  }

  openModalFromCollection(){
    if(this.modalContainer){
      this.locationCheck();
    }
  }

  closeModal(){
    if(this.modalContainer){
      this.modalContainer.style.display = 'none';
    }
  }
}
